import { RouteConfig } from "QuorumGrassroots/framework/helpers/RouteRegistry"
import { KeyDatesPage } from "./KeyDatesPage"

export const keyDatesRoutes: RouteConfig[] = [
    {
        path: "/campaign/:id/key-dates",
        component: KeyDatesPage,
        requiresLogin: true,
        pageTitle: "Key Dates",
        key: "campaign-key-dates",
    },
]
